import { render, staticRenderFns } from "./planC.vue?vue&type=template&id=48cb9831&scoped=true&"
import script from "./planC.vue?vue&type=script&lang=js&"
export * from "./planC.vue?vue&type=script&lang=js&"
import style0 from "./planC.vue?vue&type=style&index=0&id=48cb9831&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cb9831",
  null
  
)

export default component.exports